<template>
  <div>
    <div class="buscar-empleado mt-4 mb-4">
      <div class="input-group-prepend">
        <span class="icon icon-search1"></span>
      </div>
      <input
        type="search"
        :placeholder="'Buscar ' + title"
        :aria-label="'Buscar ' + title"
        autocomplete="off"
        class="form-control body_regular"
        v-model="filtro"
        style="border: 0px"
        @keyup="finishTipyng"
      />
    </div>
  </div>
</template>
<script>
//import AlertGeneral from "@/components/core/alert/alert-general.vue";
export default {
  name: "search-table",
  components: {},
  watch: {
    filtro(newValue) {
      if (newValue == "") {
        this.filtro = "";
        this.emitbuscar();
      }
    },
  },
  props: {
    title: {
      default: "",
      type: String,
    },
    delay: {
      default: 500,
      type: Number,
    },
  },
  emits: ["buscar"],
  data() {
    return {
      filtro: null,
      runTime: null
    };
  },
  beforeMount() {},
  methods: {
    emitbuscar() {
      this.$emit("buscar", this.filtro);
    },

    finishTipyng() {
      if (this.runTime) {
        clearTimeout(this.runTime);
        this.runTime = null;
      }
      this.runTime = setTimeout(() => {
        this.emitbuscar();
      }, this.delay);
    },
  },
};
</script>
<style lang="scss">
</style>